<template>
  <b-row class="pt-2">
    <template v-for="(comp, index) in this.internalFormComponents" :key="comp.uniqueTitle">
      <component
        :is="comp"
        v-if="comp"
        v-bind:items="comp.items"
        v-bind:uniqueTitle="comp.uniqueTitle"
        v-bind:formComponents="comp.formComponents"
        v-bind:columnFormat="comp.columnFormat"
        v-bind:title="comp.titleValue"
        v-bind:submissionRules="comp.submissionRules"
        v-bind:twoFactor="comp.twoFactorValue"
      />
    </template>
  </b-row>
</template>

<script>

import { markRaw } from 'vue'
import _ from 'lodash'
import Table from './table.vue'
import Form from './form.vue'
import LoginForm from './loginform.vue'
import RegisterForm from './registerform.vue'
import Chart from './chart.vue'
import Pivot from './pivot.vue'
import CustomView from './custom.vue'
import RichTextView from './richtext.vue'
import StaticImageView from './staticimage.vue'
import { shouldRenderView } from '../lib/view-visibility'
import { assignColumnFormat } from '../../../shared/column-format'
import { copySubmissionConfig } from '../../../shared/submission-redirect'
import { assignPresetFilterProps } from '../lib/preset-filter-state'

// Lazy-load Row and Column to avoid circular dependencies
// row.vue <-> row2.vue and row2.vue <-> column.vue <-> row2.vue
const getComponentMap = () => ({
  table: Table,
  pivot: Pivot,
  custom: CustomView,
  form: Form,
  login: LoginForm,
  registration: RegisterForm,
  row: require('./row.vue').default,
  column: require('./column.vue').default,
  chart: Chart,
  richtext: RichTextView,
  staticimage: StaticImageView
})

export default {
  props: ['formComponents', 'uniqueTitle'],
  data() {
    return {
      internalFormComponents: []
    }
  },
  watch: {
    formComponents: {
      immediate: true,
      handler() {

        console.log(`form formComponents handler called!`)
        console.log(this)
        console.log(this.uniqueTitle)
        console.log(this.formComponents)

        this.internalFormComponents = []
        let counter = 0

        if (!this.formComponents) {

          return
        }

        const componentMap = getComponentMap()

        for (let component of this.formComponents) {

          if (!shouldRenderView(component)) continue

          console.log(`form adding component ${component.type} with placeholder ${component.placeholder} >`)
          console.log(component)

          let instantiatedComponent = _.cloneDeep(componentMap[component.type])

          console.log(`ABOUT TO TRIGGER UPDATE WITH ${component.uniqueTitle} on`)
          console.log(instantiatedComponent)
          // Vue 3: direct assignment instead of this.$set
          instantiatedComponent.uniqueTitle = component.uniqueTitle
          instantiatedComponent.titleValue = component.title || ''

          if (component.type === `form` || component.type === `login` || component.type === `registration` || component.type === `row` || component.type === `column`) {

            instantiatedComponent.formComponents = component.components
          }

          assignColumnFormat(instantiatedComponent, component)
          copySubmissionConfig(instantiatedComponent, component)

          if (component.type === `pivot`) {

            const assignDefault = (name, value) => {

              if (!instantiatedComponent.props[name]) instantiatedComponent.props[name] = {}

              instantiatedComponent.props[name].default = value
            }

            assignDefault('userFiltering', !!component.userFiltering)
            assignDefault('searchEnabled', component.searchEnabled === true || component.searchEnabled === 'true')
            assignDefault('realtime', !!component.realtime)
            assignDefault('restrictUserFiltering', !!component.restrictUserFiltering)
            assignDefault('defaultUserFilters', component.defaultUserFilters || [])
            assignDefault('defaultUserFilterMatchMode', component.defaultUserFilterMatchMode || 'all')
            assignDefault('spreadSheetUniqueTitle', component.spreadSheet || '')
            assignDefault('pageUniqueTitle', this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle?.() || '')
            assignDefault('componentUniqueTitle', component.uniqueTitle)
            assignDefault('title', component.title || '')
            assignDefault('pivotConfig', {
              rowFields: component.rowFields || [],
              columnFields: component.columnFields || [],
              valueFields: component.valueFields || [],
              showSubtotals: component.showSubtotals,
              showRowGrandTotal: component.showRowGrandTotal,
              showColumnGrandTotal: component.showColumnGrandTotal
            })
          }

          if (component.type === `custom`) {

            const assignDefault = (name, value) => {

              if (!instantiatedComponent.props[name]) instantiatedComponent.props[name] = {}

              instantiatedComponent.props[name].default = value
            }

            assignDefault('viewCode', component.viewCode || '')
            assignDefault('viewCss', component.viewCss || '')
            assignDefault('userFiltering', !!component.userFiltering)
            assignDefault('searchEnabled', component.searchEnabled === true || component.searchEnabled === 'true')
            assignDefault('realtime', !!component.realtime)
            assignDefault('restrictUserFiltering', !!component.restrictUserFiltering)
            assignDefault('defaultUserFilters', component.defaultUserFilters || [])
            assignDefault('defaultUserFilterMatchMode', component.defaultUserFilterMatchMode || 'all')
            assignDefault('spreadSheetUniqueTitle', component.spreadSheet || '')
            assignDefault('pageUniqueTitle', this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle?.() || '')
            assignDefault('componentUniqueTitle', component.uniqueTitle)
            assignDefault('title', component.title || '')
          }

          if (component.type === `table`) {

            //instantiatedComponent.items = component.components
            instantiatedComponent.fields = component.components.map((field) => {

              return {
                label: component.label,
                key: component.uniqueTitle,
                sortable: !component.disableUserSorting && !field.disableSorting
              }
            })
          }

          //instantiatedComponent.items = await intake.getData(appSchema.pages[0].uniqueTitle, component.uniqueTitle, this.linkParent)

          console.log(`push ${component.uniqueTitle} / ${instantiatedComponent.uniqueTitle}`)

          assignPresetFilterProps(instantiatedComponent, component)

          this.internalFormComponents.push(markRaw(instantiatedComponent))

          continue
        }
      }
    }
  },
  methods: {
    onSubmit (event) {

      return event.preventDefault()
    }
  }
}
</script>
